import { render, staticRenderFns } from "./BlogCommentForm.vue?vue&type=template&id=ee05211e&"
import script from "./BlogCommentForm.vue?vue&type=script&lang=js&"
export * from "./BlogCommentForm.vue?vue&type=script&lang=js&"
import style0 from "./BlogCommentForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports